import __ from "src/utils/Translations";
import { ErrorCode } from "src/Pages/Company/OrganizationStructure/utils/errors/errorCode";
import { FieldValues, Path } from "react-hook-form";

export interface BackendError<T extends string = string> {
  code: "VALIDATION_ERROR" | "SERVER_ERROR";
  field: T;
  message: ErrorCode;
  context?: string;
}

interface ProcessedError<T extends FieldValues> {
  field: Path<T>;
  message: string;
}

interface HandleBackendErrorsConfig {
  errors: BackendError[];
  errorMessages: Record<
    string,
    string | ((field?: string, context?: string) => string)
  >;
  context?: string;
}

export const handleBackendErrors = <T extends FieldValues>({
  errors,
  errorMessages,
  context,
}: HandleBackendErrorsConfig): ProcessedError<T>[] => {
  if (!errors || !Array.isArray(errors)) {
    return [];
  }

  return errors.map((err) => {
    const field = err.field as Path<T>;
    const errorCode = err.message as ErrorCode;
    const errorContext = err.context || context;

    const errorKey = errorContext ? `${errorCode}_${errorContext}` : errorCode;
    const mappedMessage = errorMessages[errorKey] || errorMessages[errorCode];

    const errorMessage =
      typeof mappedMessage === "function"
        ? mappedMessage(field, errorContext)
        : mappedMessage || err.message || __("Nieznany błąd");
    return { field, message: errorMessage };
  });
};